import { Link } from "react-router-dom";
import {
  FaPhoneAlt,
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedinIn,
  FaWhatsapp,
  FaChevronUp,
  FaMapMarkerAlt,
  FaEnvelope,
} from "react-icons/fa";
import { Col, Container, Row } from "react-bootstrap";
import logo from "../../assets/images/logo.webp";
import { useEffect, useState } from "react";

import { getCategoryList, websiteDetails } from "../server/api";

const Footer = () => {
  const phoneNumber = "917777777";
  const message = "Hello SevaSathi, I need assistance.";

  const openWhatsApp = () => {
    window.open(
      `https://wa.me/${siteDetails.phone}?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  const [showTopBtn, setShowTopBtn] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // ========== category list get ================
  const [category, setCategory] = useState([]);
  const [siteDetails, setWebsiteDetails] = useState([]);

  const fetchCategory = async () => {
    try {
      const res = await getCategoryList();
      if (res.status === true) {
        setCategory(res.data);
      } else {
        alert("Failed to fetch categories");
      }
    } catch (error) {
      console.error("category API Error:", error);
    }
  };

  useEffect(() => {
    fetchCategory();
  }, []);

    const fetchWebsiteDetails = async () => {
      try {
        const res = await websiteDetails();
        if (res.status === true) {
          setWebsiteDetails(res.data);
        } else {
          alert("Failed to fetch categories");
        }
      } catch (error) {
        console.error("Website Details API Error:", error);
      }
    };
  
    useEffect(() => {
      fetchWebsiteDetails();
    }, []);

  return (
    <footer className="footer">
      <Container>
        <Row>
          {/* ABOUT */}
          <Col xs={12} sm={6} lg={3} className="widget-area">
            <div className="widget">
              <Link to="/" className="site_logo footer_Logo">
                <img src={logo} className="logo" />
              </Link>
              <p>
                We believe industry has an important role to play to reduce
                energy consumption, improve efficiency and reduce waste.
              </p>
              <ul className="widget_contact_wrapper social-icons">
                <li>
                  <a
                    href={`${siteDetails.faceBook}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaFacebookF />
                  </a>
                </li>
                <li>
                  <a
                    href={`${siteDetails.instagram}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaInstagram />
                  </a>
                </li>
                <li>
                  <a
                    href={`${siteDetails.twitter}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaTwitter />
                  </a>
                </li>
                <li>
                  <a
                    href={`${siteDetails.linkedin}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaLinkedinIn />
                  </a>
                </li>
              </ul>
            </div>
          </Col>

          {/* SERVICES */}
          <Col xs={12} sm={6} lg={3} className="widget-area">
            <div className="widget">
              <h3 className="widget-title">Heating Services</h3>
              <ul className="footer-links">

                {category.map((item) => (
                <li>
                  <Link to={`/services`}>{item.title}</Link>
                  {/* <Link to={`/services/${encodeURIComponent(item.title)}`}>{item.title}</Link> */}
                </li>
                  ))}

              </ul>
            </div>
          </Col>

          {/* Pages */}
          <Col xs={12} sm={6} lg={3} className="widget-area">
            <div className="widget">
              <h3 className="widget-title">Quick Link</h3>
              <ul className="footer-links">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/about-us">About Us</Link>
                </li>
                <li>
                  <Link to="/contact-us">Contact Us</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms">Terms & Condition</Link>
                </li>
                <li>
                  <Link to="/data-deletion">Data Deletion</Link>
                </li>
              </ul>
            </div>
          </Col>

          {/* CONTACT */}
          <Col xs={12} sm={6} lg={3} className="widget-area">
            <div className="widget">
              <h3 className="widget-title">Get Free Estimate</h3>
              <h3 className="footer-phone">
                {" "}
                <FaPhoneAlt className="me-2" />
                {siteDetails.phone}
              </h3>
              <p >
                <FaMapMarkerAlt className="me-2" />
                {siteDetails.address || "Loading..."}
              </p>
              <p >
                <FaEnvelope className="me-2" />
                {siteDetails.email || "Loading..."}
              </p>
              <p>Our online scheduling & payment system is safe.</p>
              <Link to="/contact-us" className="footer-btn">
                Request Online Form
              </Link>
            </div>
          </Col>
        </Row>

        <div className="chat" onClick={openWhatsApp}>
          <div className="chat_btn">
            <FaWhatsapp />
            <p>WhatsApp us</p>
          </div>
        </div>
      </Container>

      {showTopBtn && (
        <button className="scroll-top-btn" onClick={scrollToTop}>
          <FaChevronUp />
        </button>
      )}

      {/* COPYRIGHT */}
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Sevasati. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
